import { default as Sessions } from "./Sessions";
import { default as Properties } from "./Properties";
import { default as Communities } from "./Communities";
import { default as Registrations } from "./Registrations";
import { default as AppGrowth } from "./AppGrowth";
import { default as AppSessions } from "./AppSessions";
import { default as MostActiveUsers } from "./MostActiveUsers";
import { default as Notifications } from "./Notifications";
import { default as Subscriptions } from "./Subscriptions";
import { default as LoaderInline } from "./LoaderInline";
import { default as Horizontal } from "./Horizontal";
import { default as BarChart } from "./BarChart";
import { default as SelectPeriod } from "./SelectPeriod";
import { default as Pie } from "./Pie";
import { default as SubscriptionPie } from "./SubscriptionPie";
import { default as AppDownloadsPie } from "./AppDownloadsPie";
const Statistics = {
  LoaderInline,
  Sessions,
  Registrations,
  Properties,
  Communities,
  AppGrowth,
  AppSessions,
  MostActiveUsers,
  Notifications,
  Subscriptions,
  Horizontal,
  SelectPeriod,
  BarChart,
  Pie,
  SubscriptionPie,
  AppDownloadsPie,
};

export default Statistics;
